import { render } from "./PromoProductForm.vue?vue&type=template&id=56855ada&scoped=true"
import script from "./PromoProductForm.vue?vue&type=script&lang=js"
export * from "./PromoProductForm.vue?vue&type=script&lang=js"

import "./PromoProductForm.vue?vue&type=style&index=0&id=56855ada&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56855ada"]])

export default __exports__